<template>
  <transition name="slide-fade" mode="out-in">
    <router-link v-if="id"
                 :to="to"
                 class="flex items-center focus:underline gap-2"
                 :class="{ 'flex-row-reverse': isIconFirst }"
                 target="_blank"
    >
      <span class="font-medium pt-1"> {{ label }}</span>
      <vs-icon v-if="!$slots.icon" :icon="icon" :size="`${iconSize}rem`" :class="iconClasses" class="no-underline"/>
      <slot v-else name="icon"/>
    </router-link>
    <div v-else class="text-gray-dark flex items-center">
      <vs-icon icon="close" size="1rem"/>
      <span class="ml-1">{{ placeholder }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LinkTo',
  props: {
    id: {
      type: String,
      default: ''
    },
    iconSize: {
      type: [Number, String],
      default: 1
    },
    to: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    isIconFirst: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'open_in_new'
    },
    iconClasses: {
      type: String,
      default: ''
    }
  }
}
</script>
